import { faClockThreeThirtySolid, FaIcon } from '@/lib/fa'
import React from 'react'
import { useEditBusinessTripForm } from '../../../../context/EditBusinessTripFormContext'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { DateField } from '@/ui/form/controls/DateField'

const CurrenciesStage = () => {
  const { data, setData } = useEditBusinessTripForm()

  const handleDoNotConvertChange = (checked: boolean) => {
    if (checked) {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const d = String(now.getDate()).padStart(2, '0')
      const today = `${y}-${m}-${d}`
      setData((prev: any) => ({
        ...prev,
        doNotConvertCurrencies: true,
        exchangeRateDate: prev?.exchangeRateDate || today,
      }))
    } else {
      setData((prev) => ({ ...prev, doNotConvertCurrencies: false }))
    }
  }
  return (
    <div className="tw-flex tw-items-start tw-justify-between">
      <div className="tw-jusit tw-flex tw-flex-[1] tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
        <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
        <p className="tw-text-sm tw-font-semibold tw-text-content-base">
          Waluty
        </p>
      </div>

      <div className="tw-flex tw-flex-[2] tw-flex-col tw-gap-2">
        <CheckboxWithLabelField
          field="doNotConvertCurrencies"
          data={data}
          setData={setData}
          background={false}
          noPadding
          label="Przeliczaj waluty"
          onChange={handleDoNotConvertChange}
        />
        {data?.doNotConvertCurrencies && (
          <>
            <DateField
              label="Data kursu walut"
              value={data?.exchangeRateDate as any}
              setValue={(e) => setData((prev: any) => ({ ...prev, exchangeRateDate: e }))}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default CurrenciesStage
